import { Box, Typography } from '@mui/material'
import { PageBackButton } from '~/common/page-back-button/page-back-button'
import { PageContents } from '~/common/page-contents/page-contents'
import { UserPreferencesCard } from './user-preferences-card'
import { FarmPreferencesSection } from './farm-preferences-section'

const contents = [
  { title: 'User Preferences', component: <UserPreferencesCard /> },
  { title: 'Farm Preferences', component: <FarmPreferencesSection /> },
]

function Preferences() {
  return (
    <Box sx={{ position: 'relative' }}>
      <PageBackButton />
      <PageContents pageTitle="Preferences" contents={contents} />
    </Box>
  )
}

export default Preferences
